import { useState, createContext } from 'react';

export const MasterControlContext = createContext();

const MasterControlProvider = ({ children }) => {
  const [greenDetour, setGreenDetour] = useState([false, false]);
  const [isSelectedForAts, setIsSelectedForAts] = useState([
    false,
    false,
    false,
  ]);

  const [selectPrograms, setSelectPrograms] = useState({
    instantHeat: false,
    isFanOnly: false,
    snowSensor: false,
    optionalConstantTemp: false,
    heatingSchedule: false,
    windFactor: false,
  });

  const [resetDialControl, setResetDialControl] = useState(true);

  return (
    <MasterControlContext.Provider
      value={{
        greenDetour,
        setGreenDetour,
        selectPrograms,
        setSelectPrograms,
        isSelectedForAts,
        setIsSelectedForAts,
        resetDialControl,
        setResetDialControl,
      }}
    >
      {children}
    </MasterControlContext.Provider>
  );
};

export default MasterControlProvider;
